import Immutable from 'immutable';

import ErrorConstants from 'sharedreact/constants/ErrorConstants';
import ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

// exported functions
function setError (
  msg: string,
  msgParams: string[],
  info?: string,
  infoParams?: string[],
  title?: string
): void {
  const error = new ErrorData().merge({
    title: title,
    message: msg,
    messageParams: Immutable.List(msgParams),
    info: info,
    infoParams: Immutable.List(infoParams)
  });
  AppDispatcher.dispatch({
    actionType: ErrorConstants.SET_ERROR,
    error: error,
    logLevel: 'info'
  });
}

function clearError (): void {
  AppDispatcher.dispatch({
    actionType: ErrorConstants.CLEAR_ERROR,
    logLevel: 'trace'
  });
}

function setWarning (
  msg: string,
  msgParams: string[],
  info?: string,
  infoParams?: string[],
  title?: string
): void {
  const warning = new ErrorData().merge({
    title: title,
    message: msg,
    messageParams: Immutable.List(msgParams),
    info: info,
    infoParams: Immutable.List(infoParams)
  });
  AppDispatcher.dispatch({
    actionType: ErrorConstants.SET_WARNING,
    warning: warning,
    logLevel: 'info'
  });
}

function clearWarning (): void {
  AppDispatcher.dispatch({
    actionType: ErrorConstants.CLEAR_WARNING,
    logLevel: 'trace'
  });
}

export default {
  setError,
  clearError,
  setWarning,
  clearWarning
};
